.section {
  padding: 76px 0;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

.bp {
  display: flex;
  gap: 18px;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 16px;
  padding: 26px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  transition:
    box-shadow 0.22s ease,
    transform 0.22s ease;
}

.bp:hover {
  box-shadow: var(--plume-shadow-card-hover, 10px 10px 0 var(--color-complementary-yellow)); /* accent (yellow) sticker shadow */
  transform: var(--plume-hover-shift, translate(-2px, -2px));
}

.bp__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  color: var(--color-primary-grey-000);
}

.bpIconOk {
  background: var(--color-secondary-green-800); /* SECONDARY_GREEN_800 */
}

.bpIconNo {
  background: var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.bp__title {
  font-size: 18px; /* HEADING_XXS */
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 8px;
}

.bp__desc {
  font-size: 14px; /* COPY_S */
  line-height: 1.6;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  margin: 0;
}
